import ReactGA from "react-ga4";

const initializeAnalytics = (measurementId) => {
  if (measurementId) {
    ReactGA.initialize(measurementId);
  } else {
    console.warn("Google Analytics Measurement ID is not defined.");
  }
};

// This function is to track page views and is not used currently.
// There is no way to distinguish different paths with the current implementation.
const trackPageView = (path) => {
  ReactGA.pageview(path);
  ReactGA.send({ hitType: "pageview", page: path });
};

// This function tracks events with optional parameters.
const trackEvent = (event, params = {}) => {
  ReactGA.gtag("event", event, {
    ...params
  });
};

// GA Middleware
const handleGA = (field, selectedValue) => {
    // Defaults to empty array if undefined to prevent crashes.
    const trackingConfigs = field?.gaTracking || [];

    // Validation: Ensure we actually have an array to iterate
    if (!Array.isArray(trackingConfigs) || trackingConfigs.length === 0) return;

    // Iteration: specific logic for each tracking event
    trackingConfigs.forEach((config) => {
        const { event, paramKey } = config;

        // Skip malformed configs
        if (!event || !paramKey) return; 

        const trackingPayload = {
            [paramKey]: selectedValue
        };
        
        trackEvent(event, trackingPayload);
    });
};

export { initializeAnalytics, trackPageView, trackEvent, handleGA };
